<template>
  <v-row>
    <v-col
      cols="12"
      lg="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-tag-multiple"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('price_groups') }}
          </div>
        </template>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="computedAvailablePriceGroups"
              hide-selected
              :selected="priceGroups"
              multiple
              color="white"
              item-text="name"
              return-object
              :label="$t('choose') + ' ' + $t('price_group')"
              :loading="loadingAvailablePriceGroups"
              @change="addPriceGroup"
            >
              <template v-slot:selection="" />
            </v-autocomplete>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('name') }}
                    </th>
                    <th class="text-left">
                      {{ $t('priority') }}
                    </th>
                    <th />
                  </tr>
                </thead>
                <draggable
                  v-model="reversedPriceGroups"
                  tag="tbody"
                  @start="drag=true"
                  @end="drag=false"
                >
                  <tr
                    v-for="(item, index) in reversedPriceGroups"
                    :key="item.name"
                  >
                    <td style="width: 100%;">
                      {{ item.name }}
                    </td>
                    <td style="text-align: center">
                      {{ index+1 }}
                    </td>
                    <td>
                      <v-btn
                        small
                        color="red"
                        @click="removePriceGroup(item.id)"
                      >
                        {{ $t('delete') }}
                      </v-btn>
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-btn
            class="ml-auto"
            color="green"
            :loading="loading"
            @click="updatePriceGroups"
          >
            {{ $t('save') }}
          </v-btn>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
import { ROLES, SUPERUSER, ADMIN, ALL } from '../../../../utils/constants'
  export default {
    data () {
      return {
        priceGroups: [],
        availablePriceGroups: [],
        loading: false,
        loadingAvailablePriceGroups: false,
      }
    },
    computed: {
      reversedPriceGroups: {
        get () {
          const pg = [...this.priceGroups]
          return pg.reverse()
        },
        set (value) {
          this.priceGroups = value.reverse()
        },
      },
      computedAvailablePriceGroups: function () {
        const t = this.$_.differenceBy(this.availablePriceGroups, this.priceGroups, 'id')
        return t
      },
    },
    created: function () {
      this.fetchPriceGroups()
      this.fetchAvailablePriceGroups()
    },
    methods: {
      removePriceGroup: function (id) {
        const index = this.$_.findIndex(this.priceGroups, ['id', id])
        this.priceGroups.splice(index, 1)
      },
      fetchPriceGroups: function () {
        this.loading = true

        this.$get(`/customers/${this.$route.params.id}/price-groups`)
          .then(response => {
            this.priceGroups = response.data
            this.loading = false
          })
          .catch(e => {
            this.loading = false
          })
      },
      fetchAvailablePriceGroups: function () {
        this.loadingAvailablePriceGroups = true

        this.$get('/price-groups', { autocomplete: 1 })
          .then(response => {
            this.availablePriceGroups = response.data
            this.loadingAvailablePriceGroups = false
          })
          .catch(e => {
            this.loadingAvailablePriceGroups = false
          })
      },
      updatePriceGroups: function () {
        if (this.$getUser().role < SUPERUSER.val) {
          let code = window.prompt("Spørg Thomas om kodeord");
          if (code == 'thomassigernej') {
            this.$post(`/customers/${this.$route.params.id}/price-groups`, { price_groups: this.$_.map(this.reversedPriceGroups, 'id') })
            .then(response => {
              this.loading = false
              this.$toast(`${this.$t('price_groups')} ${this.$t('saved_correctly')}`)
              this.$emit('update')
            })
            .catch(e => {
              this.loading = false
            })
          } else {
            window.alert("Forkert kodeord");
          }

        } else {
          this.$post(`/customers/${this.$route.params.id}/price-groups`, { price_groups: this.$_.map(this.reversedPriceGroups, 'id') })
          .then(response => {
            this.loading = false
            this.$toast(`${this.$t('price_groups')} ${this.$t('saved_correctly')}`)
            this.$emit('update')
          })
          .catch(e => {
            this.loading = false
          })
        }

      },
      addPriceGroup: function (val) {
        const pg = this.$_.last(val)
        if (!val || !val.length) { return }
        if (!this.$_.find(this.priceGroups, ['id', pg.id])) { this.priceGroups.push(pg) }
      },
    },
  }
</script>
